<template>
  <div
    class="jobDetail browseCourses jobSearch breadcrumbs-absolute Regular"
    style="overflow:inherit"
    @click="closeSelectList"
  >
    <Breadcrumbs></Breadcrumbs>
    <BrowseCoursesSearch
      v-bind:childLogGaEvent="childLogGaEvent"
      v-bind:needOptions="true"
      v-bind:search="search"
      ref="browseC"
    ></BrowseCoursesSearch>
    <div ref="courseList" class="opp-contain row" style="background-color:#fff;">
      <div
        class="description opportunityPC coursesList col-sm-10 col-md-8 padLeft-0 padRight-0"
        :class="{'coursesListPC':$store.state.innerWidth>768}"
      >
        <div class="pad-15 row courseTotal">
          <div v-if="$store.state.language == 'en_US'">
            {{totalRows}} {{$t('message.results')}}
            {{$t('message.for')}}{{$t('message.forStart')}}{{$store.getters.getObject(course.langMap).title}}{{$t('message.forEnd')}}
          </div>
          <div v-if="$store.state.language != 'en_US'">
            {{totalRows}}{{$t('message.item')}}
              {{$t('message.for')}}{{$t('message.forStart')}}{{$store.getters.getObject(course.langMap).title}}{{$t('message.forEnd')}}
            {{$t('message.for')}}{{$t('message.results')}}
          </div>
        </div>
        <div class="pad-5 row" :class="{'margin-20':$store.state.innerWidth>768}">
          <div
            class="col-xs-6 col-sm-4 col-md-4 col-lg-3 pad-5 pointer"
            :class="{'pad-33':$store.state.innerWidth>768}"
            v-for="(course,index) in aok"
            v-if="numberBars>index&&index>=(numberBars-20)"
            v-on:click="toCoursesDetails(course)"
          >
            <div class="couses-item">
              <div class="min-height">
                <div>
                  <span
                    class="timeTip SemiBold"
                    v-for="mode in course.learningMode"
                    v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'"
                  >{{$t('message.'+$store.getters.getTrim(mode)+'')}}</span>
                  <span class="timeTip SemiBold" v-if="course.isCef">CEF</span>
                </div>
                <div class>
                  <a href="javascript:;" style="color: inherit">
                    <h4 class="SemiBold courseTitle fourline-box">{{$store.getters.getObject(course.langMap).title}}</h4>
                  </a>
                  <div>
                    <p
                      class="twoline-box"
                    >{{$store.getters.getObject(course.langMap).grantingBody[0]}}</p>
                  </div>
                </div>
              </div>
              <span class="hotPicks">
                <i class="icon-hot" v-if="course.isHotpick" style="padding: 0 15px 0 0;"></i>
                <span class="Medium" v-if="course.isHotpick">{{$t('message.hotPicks')}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="center row" data-load="loading" :class="{'opacity0':!isLoading}">
          <span class="user-writing">
            <span></span>
          </span>
        </div>
      </div>
    </div>
    <!-- <Paging  v-on:changeRow="changeStartRow" v-on:changePaging="changeSmallPaging" :courseListAll="aok" :toRows="totalRows"  ref="Page"></Paging> -->
      <div class="opp-contain opp-contain-coursesJia">
      <div class="browseCourses-bottom opportunityPC ">
        <div class="powered-by powered-by-browseCourses Bold">
            {{$t('message.Powered by')}} 
        </div>
        <div class="browseCourses-bottom-imgPlace">
          <div class="qr">
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-en/" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="qrEnTc" alt="hkqr.gov.hk Logo"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-tc/index.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="qrEnTc" alt="hkqr.gov.hk 標誌"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-sc/index.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="qrSc" alt="hkqr.gov.hk 标志"></a>
          </div>
          <div class="edx">
            <a href="https://www.edx.org" target="_blank" ><img :src="edx" alt="edx Logo"></a>
          </div>
          <div class="microsoft">
            <a href="https://docs.microsoft.com/en-gb/learn/" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="microsoft" alt="hkqr.gov.hk Logo"></a>
            <a href="https://docs.microsoft.com/zh-hk/learn/" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="microsoft" alt="hkqr.gov.hk 標誌"></a>
            <a href="https://docs.microsoft.com/zh-cn/learn/" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="microsoft" alt="hkqr.gov.hk 标志"></a>
          </div>
        </div>
      </div>
     
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import BrowseCoursesSearch from "@/components/BrowseCoursesSearchRelated";
import Swiper from "@/components/Swiper.vue";
import MessageLoading from "@/components/MessageLoading";
import { EventBus } from "@/javascripts/eventBus.js";
import Paging from "@/components/paging.vue";
import qrEnTc from '../images/QR_en_tc.jpg';
import qrSc from '../images/QR_sc.jpg';
import edx from '../images/edx-logo-registered.png';
import microsoft from '../images/Microsoft-logo_rgb_c-gray.png';
export default {
  data() {
    return {
      courses: [],
      filter: {},
      startRow: 0,
      maxRows: 100,
      dataSource: "",
      isCef: "",
      keyword: "",
      learningMode: "",
      areaOfStudy: "",
      grantingBody: "",
      isLoading: false,
      loadEnd: false,
      totalRows: 0,
      coursesType: 0,
      courseKey: "",
      course: {},
      articleDetail: [],
      aok:[],
      smallPaging:1,
      numberBars:20,
      jobId: 0,
      jobDetail: {},
      currentTitle: "",
      qrEnTc:qrEnTc,
      qrSc:qrSc,
      edx:edx,
      microsoft:microsoft,
    }
  },   
  props: ["logGaEvent"],
  components: {
    Breadcrumbs,
    Swiper,
    BrowseCoursesSearch,
    MessageLoading,
    Paging
  },
  computed: {
    _language() {
      return this.$store.state.language;
    }
  },
  created() {},
  methods: {
    closeSelectList:function(){
      if(this.$refs.Page != undefined){
         this.$refs.Page.closeSelecPagingList();
      }
     
    },
    changeSmallPaging:function(val){
        var that = this;
        this.smallPaging = val;
       
        if(this.smallPaging == 1){
          this.numberBars = 20;
        }else if(this.smallPaging == 2){
          this.numberBars = 40;
        }else if(this.smallPaging == 3){
          this.numberBars = 60;
        }else if(this.smallPaging == 4){
          this.numberBars = 80;
        }else if(this.smallPaging == 5){
          this.numberBars = 100;
        }
       window.scrollTo(0,that.$refs.courseList.offsetTop);
       
    },
    changeStartRow:function(val){
      this.startRow = val;
      if(this.$store.state.formData.jobId) {
        this.getAllJobCourseList();
      }
    },
    setBreadcrumbs: function() {
      if (this.$route.path.indexOf("ReratedCoursesC") > 0) {
        var breadcrumbs = this.$route.meta.breadcrumbs.find(function(b) {
          return b.to.indexOf("coursesDetail") > 0;
        });
        let key = encodeURIComponent(this.course.key);
        if (breadcrumbs) {
          breadcrumbs.text = this.$store.getters.getObject(
            this.course.langMap
          ).title;
          breadcrumbs.to =
            "/coursesDetail/" + this.course.dataSource + "/" + key;
        }
        
      }
    },
    childLogGaEvent: function(
      eventCategory,
      eventAction,
      eventLabel,
      eventValue
    ) {
      this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue);
    },
    toCoursesDetails: function(course) {
      let key = "";
      // if (course.dataSource == 'edx') {
      key = encodeURIComponent(course.key);
      // } else {
      //     key = course.id
      // }
      this.$router.push({path:"/courseDetailCef/" + course.dataSource + "/" + key, query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(course.langMap).title)}});
    },
    search: function(obj) {
      this.startRow = 0;
      this.courses = [];
      this.dataSource = obj.dataSource;
      this.isCef = obj.isCef;

      this.keyword = obj.keyword;
      this.learningMode = obj.learningMode;
      this.areaOfStudy = obj.areaOfStudy;
      this.grantingBody = obj.grantingBody;
      this.coursesType = 0;
    //   if (this.$store.state.formData.coursesType) {
    //     this.coursesType = this.$store.state.formData.coursesType;
    //     //  this.$store.state.formData.coursesType = 0;
    //     if (this.coursesType == 1 || this.coursesType == 2) {
    //       if(this.$store.state.formData.jobId) {
    //         this.getAllJobCourseList(obj);
    //       }
    //     } else if (this.coursesType == 3 || this.coursesType == 4) {
    //       this.getAllDetailLinkCourse(obj);
    //     }
    //   } else {
    //     if (!this.$route.params.keyword) {
    //       this.getCourseList(obj);
    //     }
    //   }
    },
    getCourseList: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;

      let that = this;
      that.isLoading = true;
      this.api.getCourseList(obj, function(data) {
        // 
        // that.startRow++;
        that.isLoading = false;
        that.totalRows = data.result.totalRows;
        let courses = data.result.result;
        for (let i = 0; i < courses.length; i++) {
          if (courses[i].learningMode) {
            courses[i].learningMode = courses[i].learningMode.split(",");
          }
          that.courses.push(courses[i]);
        }
        if (that.courses.length >= that.totalRows) {
          that.loadEnd = true;
        }
      });
    },
    getAllDetailLinkCourse: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;
      obj.key = this.courseKey;
      if (this.coursesType == 3) {
        obj.dataSource = "qr";
      } else if (this.coursesType == 4) {
        obj.dataSource = "edx";
      }
      let that = this;
      that.isLoading = true;
      this.api.getAllDetailLinkCourse(obj, function(data) {
        // 
        if(!data.result){
          data.result = {
            totalRows:0,
            result:[]
          }
        }
        that.isLoading = false;
        that.totalRows = data.result.totalRows;
        let courses = data.result.result;
        for (let i = 0; i < courses.length; i++) {
          if (courses[i].learningMode) {
            courses[i].learningMode = courses[i].learningMode.split(",");
          }
          that.courses.push(courses[i]);
        }
        if (that.courses.length >= that.totalRows) {
          that.loadEnd = true;
        }
      });
    },
    getJobPostingDetail: function() {
      var that = this;
      this.api.getJobPostingDetail({ id: that.jobId }, function(data) {
        that.jobDetail = data.result;
        that.currentTitle = data.result.title;
        that.setBreadcrumbs();
      });
    },
    getCourseDetail: function() {
      let postData = {};
      var that = this;
      // if(this.$route.params.dataSource=="edx"){
      postData.key = decodeURIComponent(this.$store.state.formData.cefCourseKey);
      // }else{
      //     postData.id=this.$route.params.key
      // }
      this.api.getCourseDetail(postData, function(data) {
        that.course = data.result;
        that.setBreadcrumbs();
      });
    },
    getAllJobCourseList: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;
      obj.jobId = this.jobId;
      if (this.coursesType == 1) {
        obj.dataSource = "qr";
      } else if (this.coursesType == 2) {
        obj.dataSource = "edx";
      }
      let that = this;
      that.isLoading = true;
      this.api.getAllJobCourseList(obj, function(data) {
        if(!data.result){
          data.result = {
            totalRows:0,
            result:[]
          }
        }
        that.isLoading = false;
        that.totalRows = data.totalRows;
        let courses = data.result;
        that.aok = data.result;
        for (let i = 0; i < courses.length; i++) {
          if (courses[i].learningMode) {
            courses[i].learningMode = courses[i].learningMode.split(",");
          }
          that.courses.push(courses[i]);
        }
        if (that.courses.length >= that.totalRows) {
          that.loadEnd = true;
        }
        window.scrollTo(0,0);  
      });
    }
  },
  mounted() {
    // EventBus.$emit('error', { errMsg: this.$i18n.t("message.developmentTip")})
    this.$store.state.selectMenu = 4;
    this.startRow = 0;
    this.getCourseDetail();
    this.aok = this.$store.state.formData.cefCourseList;  
    this.totalRows = this.aok.length;
  },
  watch: {
    _language: {
      handler: function(val, oldVal) {
         this.setBreadcrumbs();
      },
      deep: true
    }
  }
};
</script>